export function ValueMappingCommits(client) {
    return {
        get(masterAccountId, uploadSetId, uploadFileId, dataFrameId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/value-mapping-commits`);
        },
        post(masterAccountId, uploadSetId, uploadFileId, dataFrameId, createValueMappingCommitRequest) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/value-mapping-commits`, createValueMappingCommitRequest);
        },
        getById(masterAccountId, uploadSetId, uploadFileId, dataFrameId, valueMappingCommitId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/value-mapping-commits/${valueMappingCommitId}`);
        },
        putById(masterAccountId, uploadSetId, uploadFileId, dataFrameId, valueMappingCommitId, valueMappingCommitUpdate) {
            return client.put(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/value-mapping-commits/${valueMappingCommitId}`, valueMappingCommitUpdate);
        }
    };
}
